// CU-86d45b38j — a LOCAL cache namespace only: the signed-in account from the cookie partitions the React Query entries
// so a later sign-in on the same browser never reads the previous account's billing. It is never sent to finance;
// ownership there is the signed token alone.
import { getSessionUser } from "../../utils/auth/sessionUser";

export const CUSTOMER_BILLING_SCOPE_ANONYMOUS = "anonymous";

export const customerBillingCacheScope = (): string => {
	try {
		const user = getSessionUser();
		const id = user?.uuid ?? user?.id;
		return id === undefined || id === null || String(id) === "" ? CUSTOMER_BILLING_SCOPE_ANONYMOUS : String(id);
	} catch {
		return CUSTOMER_BILLING_SCOPE_ANONYMOUS;
	}
};

export const customerBillingKeys = {
	state: (scope: string) => ["customer-billing", scope] as const,
	paymentMethods: (scope: string) => ["customer-billing", scope, "payment-methods"] as const,
};
